<script setup lang="ts">
import type { MediaBlock } from '~/types/storyblok/media-block'

interface Props {
  blok: MediaBlock
}

const props = defineProps<Props>()
const { blok } = props

const { usePlayButton, colorOfPlayButton } = blok.media[0] ?? { usePlayButton: false, colorOfPlayButton: '' }
const mediaLink = blok.media[0]?.asset.filename
const altText = blok.media[0]?.altText
</script>

<template>
  <div v-editable="blok">
    <StoryblokMediaComponent
      v-if="mediaLink"
      :media-link="mediaLink"
      :use-play-button="usePlayButton"
      :color-of-play-button="colorOfPlayButton"
      :alt-text="altText"
    />
  </div>
</template>
